import * as React from "react";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import styled, {CSSProperties} from "styled-components";

interface IInputProps {
  className?: string;
  defaultValue?: string;
  hintText?: string;
  maxLength?: number;
  name: string;
  placeholder: string;
  type: string;
  inputCSSProps?: CSSProperties;
  invalidHintCSSProps?: CSSProperties;
  lengthHintCSSProps?: CSSProperties;
  onChangeCallback?: (evt: React.ChangeEvent<HTMLInputElement>) => void;
}
const InputField = styled.input`
  &[type="text"],
  &[type="email"],
  &[type="tel"] {
    float: left;
    height: 40px;
    line-height: 40px;
    width: 100%;
    &.invalid,
    &:invalid,
    &.invalid-length {
      margin-bottom: 0;
    }
    &.invalid,
    &:invalid {
      + span.invalid-hint {
        display: block;
        visibility: visible;
      }
    }
    &:invalid.invalid-length + span.invalid-hint {
      margin-bottom: 0;
    }
    &.invalid-length + span + span.length-hint {
      display: block;
      visibility: visible;
    }
  }
`;
const HintSpan = styled.span`
  color: red;
  display: none;
  font-size: 0.8rem;
  margin-bottom: 1rem;
  visibility: hidden;
`;

export const MaxLengthInput: React.FC<IInputProps> = (maxLengthInputProps) => {
  const {
    className,
    defaultValue,
    hintText,
    inputCSSProps,
    invalidHintCSSProps,
    lengthHintCSSProps,
    maxLength,
    name,
    onChangeCallback,
    placeholder,
    type,
  } = maxLengthInputProps;
  const {t} = useTranslation("checkout");
  const [{value, classes}, setValue] = useState<{value: string; classes?: string}>({
    value: defaultValue ?? "",
    classes: className,
  });

  useEffect(() => {
    setValue({value: defaultValue ?? "", classes: className});
  }, [defaultValue, className]);

  const max = maxLength ?? 50;
  const hint = hintText ?? t("Bitte ausfüllen");

  const lengthCheck = (evt: React.ChangeEvent<HTMLInputElement>) => {
    if (evt.target.value.length <= max) {
      setValue({value: evt.target.value, classes: className});
      if (onChangeCallback) {
        onChangeCallback(evt);
      }
    } else {
      setValue({value, classes: (className || "") + " invalid-length"});
    }
  };

  return (
    <React.Fragment>
      <InputField
        className={classes}
        onChange={lengthCheck}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        style={inputCSSProps}
      />
      <HintSpan className="invalid-hint" style={invalidHintCSSProps}>
        {hint}
      </HintSpan>
      <HintSpan className="length-hint" style={lengthHintCSSProps}>
        {t("Bitte maximal {{count}} Zeichen", {count: max})}
      </HintSpan>
    </React.Fragment>
  );
};
